export default () => ({
  MuiTouchRipple: {
    child: {
      backgroundColor: '#657786'
    }
  }
})
